/* global swal angular */
import './style.less';
import createCourseTemplate from 'modals/createCourse/template.html';
import createCourseController from 'modals/createCourse';
import { orderBy, uniqBy } from 'lodash';

export default function(
  $scope,
  $log,
  $state,
  $location,
  $stateParams,
  $timeout,
  $uibModal,
  Swal,
  UserClass,
  ApiClass,
  CoursesClass
) {
  'ngInject';

  const vm = this;

  this.$onInit = activate;

  vm.profile_uid = $stateParams.id;
  vm.is_admin = UserClass.admin;
  vm.is_sysAdmin = UserClass.sysAdmin;
  vm.courses = [];
  const courses = [];
  vm.resultsQueried = false;
  vm.search = '';
  vm.selfStudyUsageReportParams = {};
  vm.coursesEvaluationsReportParams = {};
  vm.deliveryGroup = [];
  vm.deliveryFilter = '';
  vm.typeFilter = 'internal';
  // dictionary for badge color
  vm.badgeColor = {
    0: 'badge-success',
    1: 'badge-info',
    2: 'badge-warning',
    8: 'badge-success'
  };

  // who is for no-content
  vm.who = "you don't";
  vm.tooltipMsg = {
    archive: 'Archive a course to remove it from view. It will remain in the database for records purposes.'
  };

  // event that will fire based on where it is in the review process
  vm.courseLinkAction = course => {
    if (vm.is_admin && course.linkText === 'In Review') {
      return $state.go('app.admin.courses.course.review', {
        id: $stateParams.id,
        courseId: course.course_id
      });
    }
    if (course.linkText === 'Edit' || course.linkText === 'In Review')
      return $state.go('app.author.courses.course.edit', {
        id: $stateParams.id,
        courseId: course.course_id
      });
    if (course.linkText === 'Duplicate') {
      return Swal.confirm(
        'Duplicate?',
        'As this course has been published to the marketplace any changes need to be made in a new course. This course will copy the same course information, but not any uploaded files.'
      )
        .then(() => {
          const updateCourse = angular.copy(course);
          return ApiClass.coursesPut({ manage: true }, { course: updateCourse, copy: true });
        })
        .then(() => activate())
        .catch(error => {
          if (error.dismiss) return;
          $log.error(error);
          throw error;
        });
    }
  };

  vm.archive = course => {
    Swal.confirm('Archive Course?', 'This cannot be undone', 'warning')
      .then(() => {
        const updateCourse = { course_id: course.course_id, archive: true };
        return ApiClass.coursesIdPatch({ id: course.course_id, manage: true }, { course: updateCourse });
      })
      .then(() => {
        Swal.toast('Archived, This course has been archived!');
        course.archive = true;
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.retrieveCourse = function(course_id) {
    Swal.confirm('Retrieve Course', 'Please click the Retrieve button to retrieve this course', 'warning')
      .then(() => {
        const course = {
          course_id: course_id,
          submitted: false,
          adminReview: false,
          active: false,
          approval: false,
          reviewAdmins: []
        };
        return ApiClass.coursesIdPatch({ id: course_id, manage: true }, { course });
      })
      .then(() => {
        swal('Course Retrieved', 'Your course has been retrieved from the marketplace', 'success');
        $state.go('app.author.courses.course.edit', { id: vm.profile_uid, courseId: course_id });
      })
      .catch(error => {
        Swal.toast('Cancelled', 'error');
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.swalResponse = () => {
    swal(
      "You're outstanding!",
      "You're admin is still reviewing this course, we will let you know when its ready!",
      'info'
    );
  };

  vm.submit = course_id => {
    $state.go('app.author.courses.course.review', {
      id: vm.profile_uid,
      courseId: course_id
    });
  };

  vm.reviewCourse = course => {
    if (vm.is_admin) $state.go('app.admin.courses.course.review', { id: vm.profile_uid, courseId: course.course_id });
    else $state.go('app.author.courses.course.edit', { id: $stateParams.id, courseId: course.course_id });
  };

  vm.addCourse = () => {
    $uibModal.open({
      template: createCourseTemplate,
      backdrop: true,
      windowClass: 'modal',
      controller: createCourseController,
      controllerAs: 'createCourseCtrl'
    });
  };

  vm.setFilters = () => {
    vm.deliveryGroup = uniqBy(courses || [], 'delivery_method').map(({ delivery_method }) => delivery_method);

    vm.coursesEvaluationsReportParams = {
      delivery_method: vm.deliveryFilter || undefined,
      type: vm.typeFilter || undefined,
      search: vm.search || undefined
    };

    vm.courses.length = 0;

    const filteredCourses = courses.filter(({ type, delivery_method }) => {
      if (vm.typeFilter && type !== vm.typeFilter) return false;

      if (typeof vm.deliveryFilter === 'number' && delivery_method !== vm.deliveryFilter) return false;

      return true;
    });

    vm.courses.push(...filteredCourses);
  };

  vm.onFilter = function(controller) {
    controller.tableState().pagination.start = 0;
  };

  function activate() {
    vm.resultsQueried = false;
    courses.length = 0;

    ApiClass.coursesGet({ courseType: 'internal' }, {}, { queryParams: { manage: true, 'filter:basic': true } })
      .then(courseResponse => {
        const rawCourses = courseResponse.data.courses.filter(({ archive }) => !archive).map(course => {
          // this course has not been submitted by the author
          if (!course.active && !course.adminApproved && course.adminReview) {
            course.linkText = 'In Review';
            course.status = 'Submitted';
            course.textClass = 'btn-primary';
            course.labelColor = 'label-warning';
            course.toolTip = 'An admin is reviewing this course to be made active in the course library';
            course.action = vm.swalResponse;
            // this course has been approved, and is in the marketplace
            return course;
          }

          if (course.adminApproved) {
            if (CoursesClass.isCourse(course)) {
              course.selfStudyReportParams = {
                course_id: course.course_id,
                manage: true
              };
            } else {
              course.courseReportParams = {
                course_id: course.course_id,
                manage: true
              };
            }
            course.courseEvaluationReportParams = {
              course_id: course.course_id,
              manage: true
            };
            course.text = 'Retract';
            course.linkText = 'Edit';
            // course.additionalLink = 'Edit';
            course.status = 'Approved';
            course.textClass = 'btn-success';
            course.labelColor = 'label-success';
            // course.textClass = 'text-warning';
            course.toolTip = 'This is active in the marketplace. Retracting it will make it inactive';
            course.action = vm.retrieveCourse;
            return course;
          }

          course.linkText = 'Edit';
          course.status = 'Draft';
          course.textClass = 'btn-primary';
          course.labelColor = 'label-danger';
          // course.toolTip = 'This course is not in the marketplace and can be editted';
          // course.action = vm.submit;
          // this course has been submitted by the author and is currently being reviewed by author
          return course;
        });

        courses.push(...orderBy(rawCourses, ['name', 'delivery_method'], ['asc', 'asc']));

        vm.setFilters();

        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/courses/controller.js